import ReactGA from "react-ga4";

/**
 * Start Google Analytics, but only when this build was given a measurement id.
 *
 * `react-ga4` throws `Require GA_MEASUREMENT_ID` on a falsy id, and every call
 * site used to run `ReactGA.initialize(...)` at module scope. So a build or a
 * test without the variable did not quietly lose analytics — the module failed
 * to evaluate, taking its whole route down with it. That is what made
 * `App.test.js` unpassable: importing `App` reaches `devices/detail` and then
 * `devices/log/logpanel`, and the throw happened before any test ran.
 *
 * Events are safe to fire either way: `react-ga4` routes them through a `gtag`
 * shim that creates `window.dataLayer` on demand, so without initialization
 * they accumulate in an array nobody reads and nothing is sent.
 */
export const initAnalytics = () => {
  // Read here rather than at module scope so a test can vary it. CRA inlines
  // the literal at build time regardless of where it is read.
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId) return;

  ReactGA.initialize(measurementId);
};
